import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { PeoPayrollProviderStaff } from 'src/pages/peoPayrollProviderUsers';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    accessRoles: [ReactRouteAccessKey.inherit],
    element: <PeoPayrollProviderStaff />,
  },
];

export const PEO_PAYROLL_PROVIDER_STAFF_ROUTE: RouteProps = {
  path: appRoutes.peoPayrollProviderStaff.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.isPeoPayrollProviderUser],
};
